import { Component } from '@angular/core';

@Component({
  selector: 'app-contract-settlement',
  template: `
    <p>
      contract-settlement works!
    </p>
  `,
  styles: [
  ]
})
export class ContractSettlementComponent {

}
